import { RemindersEditorReminderUnitValue } from '@surglogs-app/network'

export const messages = {
  optionalText: 'Optional',
  amountInputPlaceholder: 'Enter an amount',
  label: 'Reminders',
  buttonAddReminder: 'Add reminder',
  buttonAddAnotherReminder: 'Add another reminder',
  reminderUnitSelectPlaceholder: 'Select a unit',
  selectPlaceholder: 'Select an option',
  addDefault: 'Save the reminder for future use',
  unitSelectOption: {
    [RemindersEditorReminderUnitValue.DAYS]: 'Days',
    [RemindersEditorReminderUnitValue.WEEKS]: 'Weeks',
    [RemindersEditorReminderUnitValue.MONTHS]: 'Months',
    [RemindersEditorReminderUnitValue.YEARS]: 'Years',
  },
  frequency: {
    WEEKS_one: '{{count}} week before',
    WEEKS_other: '{{count}} weeks before',
    DAYS_one: '{{count}} day before',
    DAYS_other: '{{count}} days before',
    MONTHS_one: '{{count}} month before',
    MONTHS_other: '{{count}} months before',
    YEARS_one: '{{count}} year before',
    YEARS_other: '{{count}} years before',
    custom: 'Custom reminder',
  },
} as const
